import request from 'src/utils/request';

/**
 * 获取消息未读数量
 * @param {Object} params - 请求参数
 * @param {string} params.auditId - 用户ID
 * @param {string} params.time - 当前日期
 * @returns {Promise}
 */
export const getMessageCount = (params) => {
    return request.get('/app/PorkOrderRecordClient/GetMessageCount', {
        params
    });
};
